import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import API from './api.config.json';
import { Roles } from 'app/modules/users/model/Roles';
import { Observable } from 'rxjs';
import { RestResponse } from '../entities/rest.response.generic.model';
import { Usuario } from '../types/usuario.type';
import { DropDownOption } from '../types/dropdown-option.type';

@Injectable({
    providedIn: 'root'
})
export class UsuarioService {

    constructor(
        private apiService: ApiService,
    ) { }


    /**
     * Get user by abreviacion
     */
    public getUserByAbreviacion(abreviacion: string): Observable<RestResponse<Usuario>> {
        const url = (API.Usuario.getUserByAbreviacion as string)
            .replace("{abreviacion}", abreviacion);
        return this.apiService.get(url);
    }


    /**
     * Get active users abreviacions as dropdown options
     */
    getActiveUsersAbreviacions(): Observable<RestResponse<DropDownOption<number>[]>> {
        const url = API.auth.getActiveAbreviacion as string;
        return this.apiService.get(url);
    }

}